module.exports = __webpack_public_path__ + "static/media/zybuluo.9d468ba5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/zybuluo.png
// module id = 224
// module chunks = 0